import React from 'react'
import { Link } from 'react-router-dom'
import { Cover, Poster, ContactUs } from '../components'
import Tippy from '@tippy.js/react'
import '../assets/css/tippy.css'

// eslint-disable-next-line
export default () => 
<>
  <Cover clsName="communityCover">
    <Poster title='Community' subtitle='Join us'>
            <Tippy content='We happy to have you'>
        <Link to='/' className='btn-primary'>Homes</Link>
      </Tippy>
    </Poster>
  </Cover>
  <ContactUs />
</>



















/*import React from 'react'
import { Link } from 'react-router-dom'
import { Cover, Poster } from '../components'
import Tippy from '@tippy.js/react'
import '../assets/css/tippy.css'

// eslint-disable-next-line
export default () => 
  <>
    <Cover>
      <Poster title='De La Chef' subtitle='join our community'>
        <form className='form-control'>
          <input name="firstName" type="firstName" placeholder="firstName"/><br />
          <input name="lastName" type="lastName" placeholder="lastName"/><br />
          <input name="email" type="email" placeholder="email"/><br />
          <input name="password" type="password" placeholder="Password"/><br /><br />
          <Tippy content='Join Us'>
            <Link to='/' className='btn-primary'>Join</Link>
          </Tippy>  
        </form>
      </Poster>
    </Cover>        
  </>*/